(function () {
    "use strict";

    cip_StatusServer.getApplicationSummaries = function (applicantKey, successCallback) {
        $.ajax({
            url: cip_Common.toStatusUrl() + '/search/applications',
            type: 'POST',
            data: {},
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback(response);
                }
            }
        });
    };

    cip_StatusServer.getApplicationDetail = function (applicationId, successCallback) {
        $.ajax({
            url: cip_Common.toStatusUrl() + '/' + applicationId + '/detail',
            type: 'GET',
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback(response);
                }
            }
        });
    };

    cip_StatusServer.addComment = function (applicationId, commentDetail, successCallback) {
        $.ajax({
            url: cip_Common.toStatusUrl() + '/' + applicationId + '/comment',
            type: 'POST',
            data: {
                'commentDetail': commentDetail
            },
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    successCallback(response);
                }
            }
        });
    };

    cip_StatusServer.addDocument = function (applicationId, form, successCallback) {
        var options = {
            type: 'POST',
            data: {},
            useShortThrobberKey: true,
            url: cip_Common.toStatusUrl() + '/' + applicationId + '/add/document',
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    if (response.invalidInputs && response.invalidInputs.length > 0) {
                        // only show the first error if there is more than one
                        cc_UI.showErrorDialog(response.invalidInputs[0].description, "Add Document");
                    } else {
                        successCallback(response);
                    }
                }
            }
        };

        // we need to add manually since form.ajaxSubmit does not used the
        // $.ajaxSetup defaults
        options = $.extend({}, cc_Ajax.defaults, options);

        // increase timeout for slow internet connections
        options.timeout = 1000 * 60 * 5, // 5 mins;

            form.ajaxSubmit(options);
    };

    cip_StatusServer.deleteDocument = function (applicationId, documentId, successCallback) {
        cc_Ajax.serialRequest({
            url: cip_Common.toStatusUrl() + '/' + applicationId + '/delete/document/' + documentId,
            type: 'POST',
            data: {},
            allowCachedResponse: false,
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);

                } else {
                    if (response.invalidInputs && response.invalidInputs.length > 0) {
                        // only show the first error if there is more than one
                        cc_UI.showErrorDialog(response.invalidInputs[0].description, "Delete Document");
                    } else {
                        successCallback(response);
                    }
                }
            }
        });
    };

    cip_StatusServer.nextStep = function (applicationId, customOperationId, successCallback) {
        $.ajax({
            url: cip_Common.toStatusUrl() + '/' + applicationId + '/next/step/' + customOperationId,
            type: 'POST',
            handle: function (response) {
                if (response.unexpectedOutcome) {
                    cip_Common.handleUnexpectedOutcome(response);
                } else {
                    successCallback(response);
                }
            }
        });
    };
})();